var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcClientPortal = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_client_portal") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_client_portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-copy-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4-Copy",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.500000, 4.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.5,2 L11.5,2 L11.5,3 L1.5,3 L1.5,14 L7.5,14 L7.5,15 L0.5,15 L0.5,2 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(9.500000, 0.500000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-7",
  stroke: "#FFFFFF",
  cx: 6.5,
  cy: 3.5,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68503126,8.53483862 C11.0663793,8.53483862 12.9968434,10.4653027 12.9968434,12.8466508 L12.9967349,12.8772449 L12.9967349,12.8772449 L12.9849732,14.5348386 L-8.04876166e-11,14.5348386 L-8.04876166e-11,12.9855328 C-8.0487909e-11,10.5977123 1.88040493,8.64908389 4.24117948,8.53968294 L4.45069413,8.53483862 L8.68503126,8.53483862 Z M9.07952618,9.53483862 L4.0515964,9.53483862 L4.0515964,9.53483862 L3.87413514,9.53993158 C2.28854018,9.63118737 1.0263569,10.9374864 1.01003749,12.5456896 L1.01003749,12.5456896 L1,13.5348386 L12,13.5348386 L12,12.4553124 C12,10.8423793 10.6924593,9.53483862 9.07952618,9.53483862 L9.07952618,9.53483862 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
})), /*#__PURE__*/React.createElement("line", {
  x1: 4.75287863,
  y1: 6.5,
  x2: 10.7528786,
  y2: 6.5,
  id: "Line-Copy-3",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.75287863,
  y1: 10,
  x2: 8.75287863,
  y2: 10,
  id: "Line-Copy-4",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcClientPortal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_client_portal.07f60c8f66b2f026ab53e0002895ddd9.svg";